<template>
  <div>
    <v-btn :outline="selectedCount === 0"
           color="primary"
           @click="showModal"
           :disabled="disabled">
      {{buttonText}}
    </v-btn>

    <v-dialog v-model="modal" :max-width="450">
      <v-card class="my-groups-filter">
        <v-card-title class="justify-center">
          <v-btn icon class="close" @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
          <div class="w-100 text-xs-center">
            <h2 class="mb-3">{{ $t('my_group_filter_selection') }}</h2>
            <v-text-field class="mr-4 pt-1"
                          clearable
                          hide-details
                          append-icon="search"
                          v-model="searchText"
                          :placeholder="$t('groups_search_placeholder')" />
          </div>
        </v-card-title>
        <v-card-text>
          <div v-for="row in filteredRows" :key="source.key(row)" :class="tableRowClass">
            <v-radio-group v-model="selectedItem"
                           class="pa-0"
                           hide-details>
            <MyGroupsFilterListRow v-if="modal" :row="source.mapRow(row)"
                                   :idSet="idSet"
                                   :selectedButtonText="text"
                                   :show-delete-option="showDeleteOption"
                                   @selected="selected"
                                   @dgroup="dgroup"
                                   :selectedItem="selectedItem"></MyGroupsFilterListRow>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-layout row justify-space-around class="pt-1 pb-1">
            <v-btn @click="clear" :disabled="selectedItem === 0">{{$t('student.filters.clear')}}</v-btn>
            <v-btn @click="closeModal" color="primary">{{ $t('student.filters.okay') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import MyGroupsFilterListRow from './MyGroupsFilterListRow'
  import { GET_GROUPS_LIST, CLEAR_STUDENTS_LIST_FILTERS_ACTION } from '../../store/action-types'
  import { SET_SELECTED_GROUP, SWITCH_TABLE_MODE } from '../../store/mutation-types'
  import Helpers from '../../mixins/Helpers'
  import { mapMutations, mapState } from 'vuex'

  export default {
    name: 'MyGroupsFilterList',
    components: { MyGroupsFilterListRow },
    mixins: [Helpers],
    data () {
      return {
        modal: false,
        searchText: '',
        selectedButtonText: '',
        selectedItem: 0
      }
    },
    methods: {
      ...mapMutations({
        setSelectedGroup: SET_SELECTED_GROUP
      }),
      showModal () {
        this.modal = true
        this.$store.dispatch(GET_GROUPS_LIST)
      },
      closeModal () {
        this.modal = false
      },
      clear () {
        this.$emit('filter:list-change', {filterName: [], filterType: this.filterType})
        this.setSelectedGroup({})
      },
      selected (selection) {
        this.selectedItem = selection.id
        let ids = new Set(this.idSet)
        if (selection.selected) {
          ids.clear()
          ids.add(selection.id)
        } else {
          ids.delete(selection.id)
        }
        this.$emit('filter:list-change', {filterName: Array.from(ids.keys()), filterType: this.filterType})
      },
      dgroup (id) {
        if (this.selectedItem === id) {
          this.$store.dispatch(CLEAR_STUDENTS_LIST_FILTERS_ACTION)
        }
        this.modal = false
        this.$store.commit(SWITCH_TABLE_MODE, 'MYSTUDENTS')
      },
      text (x) {
        this.selectedButtonText = x
      }
    },
    props: {
      source: {
        type: Object,
        required: true
      },
      filterType: {
        type: String,
        required: true
      },
      selectedFilterText: {
        type: Function
      },
      savedMyGroupText: {
        type: String
      },
      showDeleteOption: {
        type: Boolean,
        required: true
      },
      disabled: {
        type: Boolean
      }
    },
    computed: {
      ...mapState({
        selectedGroup: state => state.groups.selectedGroup
      }),
      idSet () {
        let ids = new Set()
        Object.keys(this.source.idValues).forEach(id => {
          if (this.source.identifier === 'myGroup') {
            ids.add(parseInt(id))
          }
        })
        return ids
      },
      selectedCount () {
        return Object.keys(this.source.idValues).length
      },
      buttonTitle () {
        return this.$t(this.source.title_i18n) + ' Selection'
      },
      buttonText () {
        if (this.selectedCount === 0) {
          this.selectedFilterText({title: '', id: undefined})
          return this.$t(this.source.button_unselected_i18n)
        } else {
          let id = parseInt(Object.keys(this.source.idValues)[0])

          let selectedText
          Object.keys(this.source.items).forEach(filter => {
            if (this.source.items[filter].id === id) {
              selectedText = this.source.items[filter].name
            }
          })
          this.selectedFilterText({title: selectedText, id: id})
          return (selectedText) && selectedText.length > 12 ? selectedText.substring(0, 12) + '...' : selectedText
        }
      },
      filteredRows () {
        let text = (this.searchText === null) ? '' : this.searchText.trim()
        return this.source.items.filter(item => this.source.containsText(item, text))
      }
    },
    watch: {
      selectedGroup (value) {
        if (value.id) {
          this.selected({id: value.id, selected: true})
        }
      }
    }
  }
</script>

<style scoped>
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .my-groups-filter .card__text {
    padding: 0 40px;
    min-height: 200px;
    max-height: 50vh;
  }
  .my-groups-filter .card__title,
  .my-groups-filter .card__actions
  {
    padding: 30px 40px;
  }
  @media (max-width: 600px) {
    .my-groups-filter .card__text {
      padding: 0 30px;
    }
    .my-groups-filter .card__title,
    .my-groups-filter .card__actions
    {
      padding: 20px 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/MyGroupsFilterList.vue